import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NetworkService} from 'services/network.service';

import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';
import {Flight} from 'models/flight';

const TRAVEL = Constants.categories.individual.travel;

@Injectable()
export class IndividualTravelService {
    private flightsList: Flight[] = [];
    constructor(protected networkService: NetworkService,
                protected emissionService: EmissionService) {
    }

    public getJSON(): Observable<any> {
        return this.networkService.get('./assets/airports.json');
    }

    public addToFlightList(model: Flight): void {
        this.flightsList.push(model);
        this.sendEmissionToDashboard();
    }

    deleteFromFlightsList(index: number) {
        this.flightsList.splice(index, 1);
        this.sendEmissionToDashboard();
    }

    public getFlightsList(): Flight[] {
        return this.flightsList;
    }

    public cleanFlightList(): void {
        this.flightsList = [];
    }


    getTotalEmission(): void {
        let emission = 0, emissionTrees = 0, DollarAmt = 0, DollarAmtMonthly = 0;
        let vehicleListLength = this.flightsList.length;

        if (vehicleListLength === 1) {
            this.flightsList.map(item => {
                emission += item.emission;
                emissionTrees += item.emissionTrees;
                DollarAmt += item.DollarAmt;
                DollarAmtMonthly += item.DollarAmtMonthly;
            });

            this.sendPreparedDataToDashboard({
                emission,
                emissionTrees,
                DollarAmt,
                DollarAmtMonthly
            });
        } else {
            this.getTotalPrice();
        }
    }

    getTotalPrice(): void {
        let emission = 0, emissionTrees = 0, DollarAmt = 0, DollarAmtMonthly = 0;
        this.flightsList.map(item => {
            emission += item.emission;
        });
        this.emissionService.getTotalPrice(emission).subscribe(
            response => {
                let input = response[0];
                emissionTrees = input.emissionTrees;
                DollarAmt = input.DollarAmt;
                DollarAmtMonthly = input.DollarAmtMonthly;

                this.sendPreparedDataToDashboard({
                    emission,
                    emissionTrees,
                    DollarAmt,
                    DollarAmtMonthly
                });
            }
        );
    }

    sendPreparedDataToDashboard(emission: {emission, emissionTrees, DollarAmt, DollarAmtMonthly}): void {
        this.emissionService.setEmission({
            category: TRAVEL,
            emission: emission
        });
    }

    sendEmissionToDashboard(): void {
        this.getTotalEmission();
    }
}




// WEBPACK FOOTER //
// ./src/app/services/calculator-items/individual-travel.service.ts